import React, { useEffect, useContext } from 'react'
import { Grid } from '@material-ui/core'
import { Field } from 'react-final-form'
import { Filter, DatePicker, useFilter, AuthContext } from 'elentari'
import moment from 'moment'
import CardsTempo from './CardsTempo'
import ChartSolicitacoesTotal from './ChartSolicitacoesTotal'
import ChartSolicitacoesHora from './ChartSolicitacoesHora'
import TableSolicitacaoAnalista from './TableSolicitacaoAnalista'
import TableSolicitacaoCentroCusto from './TableSolicitacaoCentroCusto'
import ConditionalField from '../../../components/ConditionalField'
import { useHistory } from 'react-router-dom'
import { CustomAutocomplete } from '../../../components'
import EmpresaSelect from '../../Empresa/EmpresaSelect'

const validate = data => {
  return {
    dataInicio: data.dataInicio
      ? moment(data.dataInicio).isSameOrBefore(moment(data.dataFim))
        ? undefined
        : 'Data Início deve vir antes da Data Fim'
      : 'Obrigatório',
    dataFim: data.dataFim
      ? moment(data.dataFim).isSameOrAfter(moment(data.dataInicio))
        ? undefined
        : 'Data Fim deve vir depois da Data Início'
      : 'Obrigatório'
  }
}

const initialValues = {
  dataInicio: moment()
    .second(0)
    .minute(0)
    .hour(0)
    .format('YYYY-MM-DD HH:mm:ss'),
  dataFim: moment()
    .add(1, 'day')
    .second(0)
    .minute(0)
    .hour(0)
    .format('YYYY-MM-DD HH:mm:ss'),
  visualizacao: 'hoje'
}

function PainelSolicitacoesFilter() {
  const filter = useFilter({})
  const { push } = useHistory()

  useEffect(() => {
    const newParams = new URLSearchParams(initialValues)
    push(`/paineis-solicitacoes/gerais?${newParams}`)
  }, [push])

  return (
    <Filter
      {...filter}
      validate={validate}
      initialValues={initialValues}
      labels={{ find: 'Mostrar', clear: 'Limpar' }}
    >
      <Grid container spacing={2}>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            hideEmpty
            component={CustomAutocomplete}
            options={[
              { label: 'Hoje', value: 'hoje' },
              { label: 'Ontem', value: 'ontem' },
              { label: 'Histórico', value: 'historico' }
            ]}
            label="Visualização"
            name="visualizacao"
          />
        </Grid>
        <ConditionalField when="visualizacao" is="historico">
          <Grid item sm={3} xs={12}>
            <Field
              fullWidth
              component={DatePicker}
              label="Data Inicio"
              name="dataInicio"
            />
          </Grid>
          <Grid item sm={3} xs={12}>
            <Field
              fullWidth
              component={DatePicker}
              label="Data Fim"
              name="dataFim"
            />
          </Grid>
        </ConditionalField>
        <Grid item sm={3} xs={12}>
          <EmpresaSelect />
        </Grid>
      </Grid>
    </Filter>
  )
}

export default function PainelSolicitacoes(props) {
  const { user } = useContext(AuthContext)
  return (
    <>
      <PainelSolicitacoesFilter />
      <Grid container spacing={2}>
        <CardsTempo {...props} />
        <ChartSolicitacoesTotal {...props} />
        <ChartSolicitacoesHora {...props} />
        {user.realm !== 'gestor' && <TableSolicitacaoAnalista {...props} />}
        <TableSolicitacaoCentroCusto {...props} />
      </Grid>
    </>
  )
}
